import PropTypes from 'prop-types';

import styles from './DetailPanel.module.scss';
import { types } from '../helpers';
import { format2DP, currencyFormatter } from 'utils/helpers';

const DetailPanel = ({ position, data }) => {
    const { options } = data;

    const generateField = (field, rm, peer) => {
        return (
            <div className={styles.field}>
                <div className={`${styles.fieldTitle} ${styles.mgLeft}`}>
                    {field}
                </div>
                <div className={styles.fieldTitle2}>RM</div>
                <div className={styles.fieldValue2}>{rm}</div>
                <div className={styles.vs}>vs</div>
                <div className={styles.fieldTitle2}>Peer</div>
                <div className={styles.fieldValue2}>{peer}</div>
            </div>
        );
    };

    const generateValueField = (field, value) => {
        return (
            <div className={styles.field}>
                <div className={`${styles.fieldTitle} ${styles.mgLeft}`}>
                    {field}
                </div>
                <div className={styles.fieldValue2}>{value}</div>
            </div>
        );
    };

    const generateOptions = () => {
        if (data.id === types.s1) {
            return (
                <div style={{ width: '232px' }}>
                    {generateValueField(
                        'RM Revenue ($)',
                        currencyFormatter(options.totalRevenue)
                    )}
                    {generateValueField(
                        'Portfolio Unrealized Losses ($)',
                        currencyFormatter(options.negativeDelta)
                    )}
                </div>
            );
        }

        if (data.id === types.s2) {
            return (
                <div style={{ width: '232px' }}>
                    {generateField(
                        ' % CR Alerts',
                        `${format2DP(options.crAlertRm)}%`,
                        `${format2DP(options.crAlertPeer)}%`
                    )}
                    {generateField(
                        '% PRM Alerts',
                        `${format2DP(options.prmAlertRm)}%`,
                        `${format2DP(options.prmAlertPeer)}%`
                    )}
                </div>
            );
        }

        if (data.id === types.s3) {
            return (
                <div style={{ width: '232px' }}>
                    {generateField(
                        '% EO Trades',
                        `${format2DP(options.eoTradesRm)}%`,
                        `${format2DP(options.eoTradesPeer)}%`
                    )}
                </div>
            );
        }

        if (data.id === types.s4) {
            return (
                <div style={{ width: '206' }}>
                    {generateValueField(
                        'Max Client: Product',
                        `${options.maxClient}:1`
                    )}
                </div>
            );
        }

        if (data.id === types.cor) {
            return (
                <>
                    {!!options.corrS1S2 &&
                        generateValueField('S1-S2', options.corrS1S2)}
                    {!!options.corrS1S3 &&
                        generateValueField('S1-S3', options.corrS1S3)}
                    {!!options.corrS1S4 &&
                        generateValueField('S1-S4', options.corrS1S4)}
                    {!!options.corrS2S3 &&
                        generateValueField('S2-S3', options.corrS2S3)}
                    {!!options.corrS2S4 &&
                        generateValueField('S2-S4', options.corrS2S4)}
                    {!!options.corrS3S4 &&
                        generateValueField('S3-S4', options.corrS3S4)}
                </>
            );
        }
    };

    return (
        <div
            className={styles.detailPanel}
            style={{
                top: position.y,
                left: position.x
            }}
        >
            <div className={styles.title}>{options.title}</div>
            {data.id !== types.cor && (
                <div className={styles.field}>
                    <div className={styles.fieldTitle}>Rank</div>
                    <div className={styles.fieldValue}>{options.rank}</div>
                </div>
            )}
            <div className={styles.field}>
                <div className={styles.fieldTitle}>Risk Score</div>
                <div className={styles.fieldValue}>{data.score}</div>
            </div>
            {generateOptions()}
        </div>
    );
};

DetailPanel.propTypes = {
    position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }).isRequired,
    data: PropTypes.shape({
        id: PropTypes.string,
        score: PropTypes.number,
        options: PropTypes.shape({
            title: PropTypes.string,
            rank: PropTypes.string,
            corrS1S2: PropTypes.number,
            corrS1S3: PropTypes.number,
            corrS1S4: PropTypes.number,
            corrS2S3: PropTypes.number,
            corrS2S4: PropTypes.number,
            corrS3S4: PropTypes.number,
            rmRatio: PropTypes.number,
            peerRatio: PropTypes.number,
            crAlertRm: PropTypes.number,
            crAlertPeer: PropTypes.number,
            prmAlertRm: PropTypes.number,
            prmAlertPeer: PropTypes.number,
            eoTradesRm: PropTypes.number,
            eoTradesPeer: PropTypes.number,
            conceEoTradesRm: PropTypes.number,
            concEoTradesPeer: PropTypes.number,
            totalRevenue: PropTypes.number,
            negativeDelta: PropTypes.number,
            maxClient: PropTypes.number
        })
    }).isRequired
};
export default DetailPanel;
